import { useEffect } from 'react';
import CrystalContainerService from './CrystalContainerService';
import { puckTypeIcon } from './PuckContent';

export const useFetchAllDewars = (setDewarInfo, setInitialDewarInfo) => {
  useEffect(() => {
    fetchAllDewars(setDewarInfo, setInitialDewarInfo);
  }, []);
};

export const fetchAllDewars = (setDewarInfo, setInitialDewarInfo) => {
  const crystalContainerService = new CrystalContainerService();
  const fetchAllDewarsData = async () => {
    return await crystalContainerService.getAllDewars();
  };
  fetchAllDewarsData().then((data) => {
    const newData = data.map((item, index) => ({
      id: item.id,
      index: index,
      name: item.name,
      puckCount: item.puckCount,
      enable: item.enable,
      inUseFlag: item.inUse,
    }));
    setDewarInfo(newData);
    setInitialDewarInfo(newData);
  });
};

export const useFetchAllPucks = (setPuckInfo, setInitialPuckInfo) => {
  useEffect(() => {
    fetchAllPucks(setPuckInfo, setInitialPuckInfo);
  }, []);
};

export const fetchAllPucks = (setPuckInfo, setInitialPuckInfo) => {
  const crystalContainerService = new CrystalContainerService();
  const fetchAllPucksData = async () => {
    return await crystalContainerService.getAllPucks();
  };
  fetchAllPucksData().then((data) => {
    const newData = data.map((item, index) => ({
      id: item.id,
      index: index,
      name: item.name,
      pinCount: item.pinCount,
      barcode: item.barcode,
      puckType: item.puckType.name,
      puckLogo: puckTypeIcon(item.puckType.name),
      puckTypeId: item.puckType.id,
      enable: item.enable,
      inUseFlag: item.inUse,
    }));
    setPuckInfo(newData);
    setInitialPuckInfo(newData);
  });
};

export const useFetchAllPuckTypes = (setPuckTypesInfo) => {
  const crystalContainerService = new CrystalContainerService();
  useEffect(() => {
    const fetchAllPucksTypes = async () => {
      return await crystalContainerService.getAllPuckTypes();
    };
    fetchAllPucksTypes().then((data) => {
      const newData = data.map((item) => ({
        id: item.id,
        title: item.name,
        value: item.name,
        pinCount: item.pinCount,
      }));
      setPuckTypesInfo(newData);
    });
  }, []);
};
